<template>
  <div class="login-activity-section">
    <div class="activity" :class="{'disable': isDisable}">
      <div class="c-activity">
        <div class="c-name">
                    <span>
                        <span class="active">{{ formatDate(activity.date) }}</span> · {{ activity.fullLocation }}
                    </span>
          <span>{{ activity.device }}</span>
        </div>
        <div class="c-arrow" v-if="withButton">
          <ActionDropdownElement
              title="Actions"
              :options="loginActivityActions"
              type="button"
              icon="EllipsisVertical"
              class="actions-icon"
              @change="$emit('deleteActivity')"
          />

        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, type PropType} from 'vue'
import {ActionDropdownElement} from '@shared/components/elements'

import {AccountNs, type DropdownNs} from '@shared/types'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(localizedFormat)

export default defineComponent({
  name: 'LoginActivitySection',
  components: {
    ActionDropdownElement
  },
  emits: ['deleteActivity'],
  props: {
    withButton: {
      type: Boolean,
      default: false
    },
    isDisable: {
      type: Boolean,
      default: false
    },
    activity: {
      type: Object as PropType<AccountNs.LoginActivity>,
      required: false
    }
  },
  data() {
    return {
      loginActivityActions: [
        {
          name: 'Log Out',
          iconType: 'fal',
          icon: 'LogOut',
          closeOnSelect: true
        }
      ] as DropdownNs.DropdownOptionsItem[]
    }
  },
  computed: {},
  methods: {
    formatDate(value: Date): string {
      return dayjs(value).format('LL')
    }
  }
})
</script>

<style lang="scss" scoped>
.login-activity-section {
  display: flex;
  margin-bottom: var(--space-16);

  .activity {
    width: 100%;
    height: auto !important;
    text-transform: none !important;
    line-height: 20px;
    padding: var(--space-12);
    background-color: var(--card-bg);
    box-shadow: var(--card-shadow);
    border-radius: $br-sm;

    &:hover {
      box-shadow: var(--card-shadow-active);
    }

    &.disable {
      background-color: var(--light-300);
    }

    .c-activity {
      display: flex;

      .c-image {
        width: 40px;
        height: 40px;
        margin-right: var(--space-16);
        background-color: var(--neutral-200);
        border-radius: $br-sm;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--text-light);
        font-weight: 500;
        mask-image: url("data:image/svg+xml,%3Csvg clip-rule='evenodd' fill-rule='evenodd' viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m18.947 18.947c-13.32 13.32-17.947 42.57-17.947 109.053s4.626 95.732 17.947 109.053c13.32 13.32 42.57 17.947 109.053 17.947s95.732-4.626 109.053-17.947c13.32-13.32 17.947-42.57 17.947-109.053s-4.626-95.732-17.947-109.053c-13.32-13.32-42.57-17.947-109.053-17.947s-95.732 4.626-109.053 17.947z' fill-rule='nonzero' stroke='%23000' transform='matrix(.992126 0 0 .992126 1.00787 1.00787)'/%3E%3C/svg%3E");
        mask-position: center center;
        mask-repeat: no-repeat;

        img {
          width: 40px;
          height: 40px;
          border-radius: $br-sm;
        }
      }

      .c-name {
        display: flex;
        align-items: flex-start;
        flex-direction: column;

        span:first-child {
          font-size: var(--fs-12);
          color: var(--text-neutral);

          .active {
            color: var(--green-100);
          }
        }

        span:nth-of-type(2) {
          font-size: var(--fs-14);
          font-weight: 500;
        }
      }

      .c-arrow {
        margin-left: auto;
        margin-right: var(--space-0);
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
